// extracted by mini-css-extract-plugin
export default {"item":"item_item__61IPk","icon":"item_icon__FpliD"};